export const paginator_configuration = {
  root: {
    padding: "0.5rem 1rem",
    gap: "0.25rem",
    borderRadius: "5px",
    background: "#fff",
    fontSize: "20px",
  },

  jumpToPageInput: {
    maxWidth: "2.5rem",
  },

  colorScheme: {
    light: {
      background: "#f6f7fd",

      navButton: {
        background: "#f6f7fd",
        hoverBackground: "#fff",
        selectedBackground: "#fff",
        color: "#485464",
        width: "2rem",
        height: "2rem",
        borderRadius: "5px",
      },
      currentPageReport: {
        color: "{text.muted.color}",
      },
    },
    dark: {
      background: "#111a2c",
      navButton: {
        background: "#111a2c",
        hoverBackground: "#1C3086",
        selectedBackground: "#1C3086",
        color: "#fff",
        width: "2rem",
        height: "2rem",
        borderRadius: "5px",
        selectedColor: "#fff",
      },
      currentPageReport: {
        color: "{text.muted.color}",
      },
    },
  },
};
